<template>
  <div class="universalPopover">
    <el-dialog
      v-model="curDialogVisible"
      center
      :show-close="false"
      :close-on-click-modal="false"
      @closed="cancelDo"
    >
      <div class="bg">
        <p class="p1">{{ title }}  <span class="p2">{{ brightTitle }}</span></p>
      </div>
      <template #footer>
        <section class="bottom" v-if="nomarlConfirm">
          <el-button size="small" class="no-btn btn" @click="cancelDo"
            >{{ cancelName }}</el-button
          >
          <el-button size="small" class="yes-btn btn" @click="comfirmDo"
            >{{ confirmName }}</el-button
          >
        </section>
        <section class="bottom" v-else>
          <el-button size="small" class="no-btn btn" @click="comfirmDo"
            >{{ confirmName }}</el-button
          >
          <el-button size="small" class="yes-btn btn" @click="cancelDo"
            >{{ cancelName }}</el-button
          >
        </section>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "universalPopover",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    brightTitle: {
      type: String,
      default: "",
    },
    nomarlConfirm: {
      type: Boolean,
      default: true,
    },
    confirmName: {
      type: String,
      default: "Confirm",
    },
    cancelName: {
      type: String,
      default: "Cancel",
    }
  },
  computed: {
    curDialogVisible() {
      return this.dialogVisible;
    },
  },
  data() {
    return {};
  },
  methods: {
    cancelDo() {
      this.$emit("cancelDo");
    },
    comfirmDo() {
      this.$emit("comfirmDo");
    },
  },
  created() {},
};
</script>
<style lang='less' scoped>
.bg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.p1 {
  font-size: 17px;
  color: #565656;
  font-weight: bold;
  // display: flex;
  // flex-direction: row;
  .p2 {
  font-size: 17px;
  color: #0a58d6;
  font-weight: bold;
}
}



.bottom {
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 5px;
  .btn {
    font-size: 15px;
    width: 88px;
    justify-content: center;
    align-items: center;
  }
  .no-btn {
    background-color: #f5f5f5;
    color: #a6a6a6;
  }
  .yes-btn {
    margin-left: 20px;
    background-color: #0052d9;
    color: #ffffff;
  }
}

:deep(.el-dialog--center .el-dialog__body) {
  padding: 0px 0px 30px;
}

:deep(.el-dialog) {
  border-radius: 8px;
  width: 480px !important;
  padding: 20px 5px 0px 5px;
}
</style>